import {
  Box,
  Text,
  Flex,
  Button,
  Link,
  Icon,
  Stack,
} from "@chakra-ui/react";
import { FaFacebookSquare, FaLinkedin, FaInstagram } from "react-icons/fa";
import { motion } from "framer-motion";
import React from "react";

const MotionBox = motion(Box);

export const Footer: React.FC = () => {
  return (
    <MotionBox
      as="footer"
      bg="black"
      color="white"
      pt={8}
      pb={6}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      <Box maxW="7xl" mx="auto" px={{ base: 6, md: 4 }}>
        <Flex
          flexWrap="wrap"
          justifyContent={{ base: "center", lg: "space-between" }}
          textAlign={{ base: "center", lg: "left" }}
        >
          <Box w={{ base: "full", lg: "50%" }} px={4}>
            <Text as="h4" fontSize="3xl" fontWeight="bold" color="white">
              Let's keep in touch!
            </Text>
            <Text fontSize="lg" mt={2} mb={4} color="gray.300">
              Find us on any of these platforms, we respond within 1-2 business days.
            </Text>
            <Stack direction="row" spacing={2} justify={{ base: "center", lg: "start" }}>
              <Button
                as="a"
                href="https://facebook.com/IdyllConsultsInternational"
                target="_blank"
                bg="white"
                color="black"
                boxShadow="md"
                rounded="full"
                aria-label="Visit us on Facebook"
                _hover={{ transform: "scale(1.1)", bg: "gray.100" }}
              >
                <Icon as={FaFacebookSquare} />
              </Button>
              <Button
                as="a"
                href="https://www.linkedin.com/company/idyll-consults-and-allied-limited"
                target="_blank"
                bg="white"
                color="black"
                boxShadow="md"
                rounded="full"
                aria-label="Visit us on LinkedIn"
                _hover={{ transform: "scale(1.1)", bg: "gray.100" }}
              >
                <Icon as={FaLinkedin} />
              </Button>
              <Button
                as="a"
                href="https://instagram.com/Idyllconsults"
                target="_blank"
                bg="white"
                color="black"
                boxShadow="md"
                rounded="full"
                aria-label="Visit us on Instagram"
                _hover={{ transform: "scale(1.1)", bg: "gray.100" }}
              >
                <Icon as={FaInstagram} />
              </Button>
            </Stack>
          </Box>

          <Flex
            w={{ base: "full", lg: "50%" }}
            direction={{ base: "column", md: "row" }}
            justify={{ base: "center", lg: "space-between" }}
            align={{ base: "center", md: "flex-start" }}
            px={4}
            gap={6}
            mt={{ base: 6, lg: 0 }}
          >
            <Box>
              <Text textTransform="uppercase" fontWeight="bold" fontSize="sm" color="gray.400" mb={2}>
                Useful Links
              </Text>
              <Stack spacing={2}>
                <Link href="/about" color="gray.300" _hover={{ color: "white" }}>
                  About Us
                </Link>
                <Link href="/services" color="gray.300" _hover={{ color: "white" }}>
                  Our Service
                </Link>
              </Stack>
            </Box>
            <Box>
              <Text textTransform="uppercase" fontWeight="bold" fontSize="sm" color="gray.400" mb={2}>
                Other Resources
              </Text>
              <Stack spacing={2}>
                <Link href="/contact" color="gray.300" _hover={{ color: "white" }}>
                  Contact Us
                </Link>
              </Stack>
            </Box>
          </Flex>
        </Flex>

        <Box borderTop="1px solid" borderColor="gray.700" my={6} />

        <Flex justify="center" textAlign="center">
          <Text fontSize="sm" color="gray.400">
            Copyright © {new Date().getFullYear()} || Idyll Consults LTD.
          </Text>
        </Flex>
      </Box>
    </MotionBox>
  );
};
